export default class Themable extends HTMLElement {
  // Attribute: theme
  // CSS file to use as a theme.
  get theme() {
    return this.getAttribute('theme');
  }
  set theme(value) {
    this.setAttribute('theme', value ?? '');
  }

  applyTheme() {
    const root = this.shadowRoot ?? document;

    if (this.theme === null) {
      root.querySelectorAll('#theme,#inline-theme').forEach(el => el.remove());
    } else if (this.theme.startsWith('http') || this.theme.startsWith('/') || this.theme.startsWith('data:')) {
      this.applyExternalTheme(root, this.theme);
    } else {
      this.applyInlineTheme(root, this.theme);
    }
  }

  applyInlineTheme(root: ParentNode, theme: string) {
    root.querySelectorAll('#theme,#inline-theme').forEach(el => el.remove());

    const style = document.createElement('style');
    style.id = 'inline-theme';
    style.textContent = theme;
    this.appendStyleTag(style);
  }

  applyExternalTheme(root: ParentNode, theme: string) {
    root.querySelectorAll('#inline-theme').forEach(el => el.remove());
    let link = root.querySelector('#theme') as HTMLLinkElement | null;
    if (link) {
      if (link.href !== this.theme) link.href = theme;
    } else {
      link = document.createElement('link');
      link.id = 'theme';
      link.rel = 'stylesheet';
      link.href = theme;
      this.appendStyleTag(link);
    }
  }

  appendStyleTag(style: HTMLLinkElement | HTMLStyleElement) {
    if (this.shadowRoot) {
      this.shadowRoot.append(style);
    }
    else {
      document.head.append(style);
    }
  }
}
